import React from "react";
import { Box } from '@curves/ui-base';

import img_pdf from "@Images/pdf.png";
import useShowPDF from "@Util/hook/useShowPDF";
const ChangeRecordCardAttachment = ({ pdfUrl, onClick }) => {
	const showPDF = useShowPDF();
	const handleClick = (e) => {
			showPDF({
				open: true,
				pdfUrl: pdfUrl,
			});
	}
	return (
		<Box className="change-record-card__attachment" onClick={handleClick}>
			<img src={img_pdf} alt="PDF 預覽" />
		</Box>
	);
};
export default ChangeRecordCardAttachment;